import React, { useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';

import { ComponentsDispatch } from '../store';
import { setterGant } from '../store/slices/gantSlice';

interface IGantContainer {
    children: React.JSX.Element | React.JSX.Element[];
}

const GantTableContainer: React.FC<IGantContainer> = ({ children }) => {
    const dispatch = useDispatch<ComponentsDispatch>();

    const [heightContainer, setHeightContainer] = useState(0);
    const containerParent = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (!containerParent.current) {
            return;
        }
        const observer = new ResizeObserver((entries) => {
            for (const entry of entries) {
                const newHeight = entry.contentRect.height;
                setHeightContainer(newHeight);
            }
        });
        observer.observe(containerParent.current);
        return () => observer.disconnect();
    }, []);

    useEffect(() => {
        dispatch(setterGant({ availableHeightTable: heightContainer - 2 }));
    }, [heightContainer]);

    return (
        <div
            ref={containerParent}
            style={{
                flex: 1,
                minHeight: 0,
            }}
        >
            {children}
        </div>
    );
};

export default React.memo(GantTableContainer);
